<template>
    <div class="is-relative card-wrapper" v-e2e="'card-wrapper-element'">
      <div class="card card-background mb-5 is-flex is-justify-content-space-between"
      :style="{ 'background-color': bgColor }">
        <div>
            <div class="card-header-title pb-0 pr-0"> {{ nome }}</div>
            <span class="button card-content is-loading quantidade-loading" v-if="isLoading"></span>
            <div class="card-content quantidade-tarefas" v-if="!isLoading"> {{ quantidade }}</div>
        </div>
        <div>
            <div class="card-content icon-container pt-4 pb-0 pl-0">
              <FontAwesomeIcon :icon="icone" size="3x"/>
            </div>
        </div>
      </div>
      <div v-if="deveMostrarToolTip" class="tooltip">
        {{ tooltip }}
      </div>
    </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

library.add(fas)
  
export default {
  name: "CardDashboard",
  components: {
    FontAwesomeIcon
  },
  props: {
    nome: String,
    quantidade: [Number, String],
    icone: String,
    isLoading: Boolean,
    tooltip: {
      type: String,
      default: '',
      required: false
    },
    bgColor: {
      type: String,
      default: '',
      required: false
    },
    quebrarLinhaNaTooltip: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  methods: {
    deveQuebrarLinhaNaTooltip() {
      return this.quebrarLinhaNaTooltip ? 'normal' : 'nowrap';
    },
  },
  computed: {
    deveMostrarToolTip() {
      return this.tooltip != "";
    }
  }
};
</script>
<style lang="scss" scoped>
  .card {
    width:100%;
    min-width:178px;
  }
  .card-background {
      background-color: #3186AA;
      color: #fff;
  }
  .card-header-title {
    color: #fff;
  }
  .quantidade-tarefas {
    font-size: 20px;
    padding-top: 0;
    padding-bottom: 12px;
  }
  .quantidade-loading {
    border-color: transparent;
    margin-left: 30px;
    margin-bottom: 8px;
    padding: 0px;
  }

  .card-content.icon-container {
    padding-right: 20px;
  }

.tooltip {
  pointer-events: none;
  opacity: 0;
  min-width: auto;
  padding: 0.5em 0.5em;
  position: absolute;
  z-index: 1;
  top: 80%;
  border-radius: 5px;
  background-color: #fff;
  //box-shadow: 0 2px 15px rgb(50 50 93 / 10%), 0 2px 15px rgb(0 0 0 / 7%);
  transition: opacity 0.35s ease 0s;
  font-size: 12px;
}

.card:hover + .tooltip {
  opacity: 0.75;
  pointer-events: auto;
}
</style>
